import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputConfig } from "../../../../types";
import { UiLibraryModule } from "../../../../template-ui.module";
import { DocMeta } from "../../../../decorators";
import { EzBaseComponent } from "@template-ui/components/ez-base.component";

@DocMeta({
  hide: true,
  showcaseTitle: "Section Spacer Sample",
  showcaseDesc: `
  ## Section Spacer Sample

  This sample highlights how to insert the optional \`ez-section-spacer\` helper around form inputs.

  - Use \`sectionSpacer.before\` and \`sectionSpacer.after\` to inject spacer blocks before or after a control.
  - Each spacer can add vertical space with \`spacingScale\`.
  - Optional horizontal rules support the \`on-tab\`, \`on-panel\`, and \`on-page\` variants or any custom class.
  `
})
@Component({
    selector: "ui-form-section-spacer-sample, ez-form-section-spacer-sample",
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        // EZ
        UiLibraryModule,
    ],
    templateUrl: "./ez-form-section-spacer-sample.component.html",
    styleUrls: ["./ez-form-section-spacer-sample.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EzFormSectionSpacerSampleComponent extends EzBaseComponent {
  constructor() {
    super();
    this.thisClassName = 'EzFormSectionSpacerSampleComponent';
  }


  spacerDemoConfig: InputConfig[] = [
    {
      type: "text",
      name: "requestTitle",
      label: "Request Title",
      width: "2x",
      sectionSpacer: {
        after: [
          { spacingScale: 2 },
          { hrVariant: "on-panel" }
        ]
      }
    },
    {
      type: "text",
      name: "requestOwner",
      label: "Request Owner",
      width: "1x"
    },
    {
      type: "text",
      name: "requestOwnerEmail",
      label: "Owner Email",
      width: "1x",
      sectionSpacer: {
        before: [
          { spacingScale: 1, hrVariant: "on-tab" }
        ]
      }
    },
    {
      type: "textarea",
      name: "summary",
      label: "Summary",
      width: "fill",
      sectionSpacer: {
        after: [
          { spacingScale: 3 },
          { spacing: false, hr: true, hrClass: "custom-spacer-divider" }
        ]
      }
    },
    {
      type: "date",
      name: "requestedBy",
      label: "Requested By",
      width: "1x",
      sectionSpacer: {
        before: [
          { spacing: false, hrVariant: "on-page" }
        ]
      }
    },
    {
      type: "date",
      name: "dueBy",
      label: "Due By",
      width: "1x"
    },
    {
      type: "checkbox",
      name: "requiresApproval",
      label: "Requires Approval",
      width: "1x",
      sectionSpacer: {
        after: [
          { spacingScale: 1 }
        ]
      }
    },
    {
      type: "textarea",
      name: "approverNotes",
      label: "Approver Notes",
      width: "fill",
      sectionSpacer: {
        before: [
          { spacingScale: 1 },
          { spacing: false, hr: true, hrClass: ["custom-spacer-divider", "custom-spacer-divider--dashed"] }
        ]
      }
    }
  ];
}
